var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Component from "nuxt-class-component";
import { TsVue } from "~/plugins/TsVue";
import _ from 'lodash';
import { saasForeign } from '~/request/api/Common';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isShow = false;
        _this.isRequest = false;
        _this.ruleForm = {
            contact_name: '',
            tel: '',
            company_name: ''
        };
        _this.rules = {
            contact_name: [
                { required: true, message: '请输入姓名', trigger: 'blur' },
                { min: 2, message: '最少 2 个字符', trigger: 'blur' }
            ],
            tel: [
                { required: true, message: '请输入手机号', trigger: 'blur' },
                { validator: _this.isPhoneNumber, trigger: 'blur' }
            ],
            company_name: []
        };
        return _this;
    }
    default_1.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2];
            });
        });
    };
    default_1.prototype.isPhoneNumber = function (rule, value, callback) {
        var a = this.isPhone(value);
        if (a) {
            callback();
        }
        else {
            callback(new Error('您输入的手机号有误'));
        }
    };
    default_1.prototype.isPhone = function (value) {
        if (value === '' || value === undefined) {
            return false;
        }
        else {
            if (/(^1[3|4|5|7|8|9]\d{9}$)|(^09\d{8}$)/.test(_.trim(value))) {
                return true;
            }
            else {
                return false;
            }
        }
    };
    default_1.prototype.submitForm = function (formName) {
        var _this = this;
        if (this.isRequest)
            return;
        this.isRequest = true;
        this.$refs[formName].validate(function (valid) { return __awaiter(_this, void 0, void 0, function () {
            var _a, success, _b, error;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!valid) return [3, 2];
                        return [4, saasForeign(this.$axios, { params: 'TenantApply' }).create(this.ruleForm)];
                    case 1:
                        _a = (_c.sent()).data, success = _a.success, _b = _a.error, error = _b === void 0 ? {} : _b;
                        this.isRequest = false;
                        if (!success)
                            return [2, this.$message.error(error.message || '服务器繁忙，请稍后再试！')];
                        this.$message({
                            message: '恭喜你，提交成功，我们会尽快联系您！',
                            type: 'success'
                        });
                        return [3, 3];
                    case 2:
                        this.isRequest = false;
                        return [2, false];
                    case 3: return [2];
                }
            });
        }); });
    };
    default_1 = __decorate([
        Component
    ], default_1);
    return default_1;
}(TsVue));
export default default_1;



//////////////////
// WEBPACK FOOTER
// /opt/node_modules/ts-loader?{"appendTsSuffixTo":[{}],"transpileOnly":true}!/opt/node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/index/Contact.vue
// module id = jA+7
// module chunks = 2